import { UiEventMessage } from './ui-event-service';

export class UnauthorizedMessage extends UiEventMessage {
  constructor() {
    super();
  }
}
